import { z } from 'zod';

/**
 * Wire shape for AG Grid Client-Side Row Model endpoints — the backend returns
 * the full row set, column defs and optional sub-headers in one payload; AG Grid
 * handles paging and filtering client-side. Items/headers/sub-headers are opaque
 * at the envelope level; per-endpoint schemas may narrow them.
 */
export const ClientSideGridResponseSchema = z.object({
  headers: z.array(z.unknown()),
  sub_headers: z.array(z.unknown()).optional(),
  items: z.array(z.unknown()),
});

export type ClientSideGridResponse<Headers = unknown, SubHeaders = unknown, Items = unknown> = {
  headers: Headers[];
  sub_headers?: SubHeaders[];
  items: Items[];
};
